module.exports = __webpack_public_path__ + "static/media/home3.43937538.jpg";